<template>
  <v-app id="app">
    <!-- <Notifications /> -->
    <sidebar>
      <slot name="header" />
    </sidebar>
    <Appbar />
    <v-main id="content">
      <v-container fluid pa-0>
        <slot></slot>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Appbar from "../components/App/Appbar.vue";
import Sidebar from "../components/App/Sidebar.vue";

export default {
  components: {
    Sidebar,
    Appbar,
  },

  computed: {
    langCode() {
      return this.$store.getters.lang_code;
    },
  },

  watch: {
    langCode: {
      immediate: true,
      handler(newLang) {
        if (newLang && newLang !== "all") {         
          this.$i18n.locale = newLang;
        }
      },
    },
  },

  async created() {
    await this.$store.dispatch("getLangCode");
  },
};
</script>

<style lang="scss">
#app {
  background-color: #eee;
}
select {
  border: 1px solid black;
  text-align: center;
  padding: 0 10px;
}
</style>
